module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-LightSemiCn.ac81a53.eot";